import { Component, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/core/base.component';
import { SessionService } from 'src/app/shared/services/session.service';
import { StripeSearchOptions } from 'src/app/shared/models/stripe/stripe-search-options';
import { StripSearchResult } from 'src/app/shared/models/stripe/stripe-search-result';
import { StripeCustomerData } from 'src/app/shared/models/stripe/stripe-customer-data';
import { GtStripeService } from 'src/app/shared/services/gt-stripe.service';
import { StripeProductData } from 'src/app/shared/models/stripe/stripe-product-data';
import { MatDialog } from '@angular/material/dialog';
import { StripePaymentModalComponent } from 'src/app/shared/modals/stripe-payment-modal/stripe-payment-modal.component';
import { environment } from 'src/environments/environment';
import { AlertModalComponent } from 'src/app/shared/modals/alert-modal/alert-modal.component';
import { StripeConnectExpressCreateModalComponent } from 'src/app/shared/modals/stripe-connect-express-create-modal/stripe-connect-express-create-modal.component';
import { AccountService } from '../../account.service';
import { StripeAddPaymentModalComponent } from 'src/app/shared/modals/stripe-add-payment-modal/stripe-add-payment-modal.component';
import { StringHelpers } from 'src/app/shared/helpers/string-helpers';

declare var Stripe: any;

@Component({
    selector: 'app-my-account-billing',
    templateUrl: './my-account-billing.component.html',
    styleUrls: ['./my-account-billing.component.scss'],
    standalone: false
})
export class MyAccountBillingComponent extends BaseComponent implements OnInit {
  private option: StripeSearchOptions = new StripeSearchOptions();
  public stripeCustomer: any;
  public subscription: any;
  public doesHaveSubscription: boolean = false;
  public products: any;

  public currentSubscription = {
    id: '',
    productId: '',
    active: false
  };

  constructor(public sessionService: SessionService,
    private accountService: AccountService,
    private stripeService: GtStripeService,
    public dialog: MatDialog,
    stringHelpers: StringHelpers) {
    super(sessionService, stringHelpers);
  }

  ngOnInit(): void {
    this.getCustomer();
  }

  getCustomer() {
    this.isLoading = true;
    this.option.query = `metadata['GolfTechId']:'${this.sessionService.getUserId()}'`;
    this.stripeService.getCustomer(this.option).subscribe((result: StripSearchResult<StripeCustomerData>) => {
      this.stripeCustomer = result.data[0];
      if (this.stripeCustomer.subscriptions.data.length > 0) {
        this.getSubscription(this.stripeCustomer.subscriptions.data);
      } else {
        this.getProducts();
      }
    }, err => {
      console.log(err);
      this.isLoading = false;
    })
  }

  getSubscription(subscription: Array<any>) {
    this.stripeService.getCustomerSubscription(subscription[0].id).subscribe((result: any) => {
      this.subscription = result;
      this.doesHaveSubscription = true;
      this.getProducts();
    }, err => {
      console.log(err);
      this.isLoading = false;
    });
  }

  getProducts() {
    this.stripeService.getProducts({platform: "outing"}).subscribe((result: any) => {
      this.products = result.data;
      if (this.doesHaveSubscription) {
        this.products.forEach(product => {
          if (product.id === this.subscription.items.data[0].plan.product.id) {
            if (this.subscription.items.data[0].plan.product.name.includes('Internal')) {
              let subMetaData = new Map<string, string>(Object.entries(this.subscription.items.data[0].plan.product.metadata));
              this.currentSubscription.productId = subMetaData.get('product_link');
            } else {
              this.currentSubscription.productId = product.id
            }
            this.currentSubscription.id = this.subscription.id;
            this.currentSubscription.active = true;
          }
        });
      }
      this.isLoading = false;
    }, err => {
      console.error(err);
      this.isLoading = false;
    });
  }

  createSubscription(product: StripeProductData) {

    if (product.defaultPrice.unitAmount > 0) {
      const dialogRef = this.dialog.open(StripePaymentModalComponent, {
        width: '45vw'
      });
      dialogRef.componentInstance.product = product;

      dialogRef.afterClosed().subscribe((response) => {
        if (response == 'Save') {
          //create subscription
        }
      });
    } else {

      const dialogRef = this.dialog.open(StripeConnectExpressCreateModalComponent, {
        width: '35vw'
      });

      dialogRef.componentInstance.businessDetailsForm.get('golfTechId').patchValue(this.getUserIdFromSession());
      dialogRef.componentInstance.businessDetailsForm.get('refreshUrl').patchValue(`${environment.dashboardLocation}/my-account/${this.getUserIdFromSession()}`);
      dialogRef.componentInstance.businessDetailsForm.get('returnUrl').patchValue(`${environment.dashboardLocation}/my-account/${this.getUserIdFromSession()}`);
      dialogRef.componentInstance.businessDetailsForm.get('emailAddress').patchValue(this.getUserFromSession().email);
      dialogRef.componentInstance.businessDetailsForm.get('name').patchValue(`${this.getUserFromSession().firstName} ${this.getUserFromSession().lastName}`);

      dialogRef.afterClosed().subscribe(dialogResult => {
        if (dialogResult) {
          this.isLoading = true;
          let data = {
            customerId: this.stripeCustomer.id,
            priceId: product.defaultPrice.id,
            cashGolferProductLink: new Map<string, string>(Object.entries(product.metadata)).get("product_link")
          };
          this.stripeService.createSubscription(data).subscribe({
            next: () => {
              if (this.getUserFromSession().stripeAccountId === undefined || this.getUserFromSession().stripeAccountId === null) {
                this.stripeService.onboardStripeConnectAccount(dialogResult).subscribe((result: any) => {
                  if (result) {
                    const dialogRef = this.dialog.open(AlertModalComponent, {
                      width: '35vw'
                    });

                    let user = this.sessionService.getUser();
                    user.stripeAccountId = result.id;
                    this.sessionService.setUser(user);

                    dialogRef.componentInstance.title = "Action Items";
                    dialogRef.componentInstance.body = "Please complete the following items to accept payments.<br/><br/><ul><li>Finish Account Set up from Email</li><li>Add Payment Method on file</li>";
                    dialogRef.componentInstance.submitText = "Okay";

                    dialogRef.afterClosed().subscribe({
                      next: () => {
                        const paymentDialog = this.dialog.open(StripeAddPaymentModalComponent, {
                          width: '45vw',
                          disableClose: true
                        });
                    
                        paymentDialog.componentInstance.customerId = this.stripeCustomer.id;
                        paymentDialog.componentInstance.showCloseButton = false;

                        paymentDialog.afterClosed().subscribe(() => {
                          this.isLoading = false;
                          this.getCustomer();
                        });
                        this.isLoading = false;
                      }
                    });
                  }
                }, err => {
                  console.log(err);
                  this.isLoading = false;
                });
              } else {
                const needsCc = new Map<string, string>(Object.entries(product.metadata)).get("need_cc_on_file")
                if (needsCc === 'true') {
                  this.accountService.getStripeCustomerPaymentMethods(this.stripeCustomer.id).subscribe({
                    next: (result) => {
                      if (result.length === 0) {
                        const paymentDialog = this.dialog.open(StripeAddPaymentModalComponent, {
                          width: '45vw',
                          disableClose: true
                        });
                    
                        paymentDialog.componentInstance.customerId = this.stripeCustomer.id;
                        paymentDialog.componentInstance.showCloseButton = false;

                        paymentDialog.afterClosed().subscribe(() => {
                          this.isLoading = false;
                          this.getCustomer();
                        });
                      }
                    },
                    error: (err) => {
                      this.isLoading = false;
                      console.log(err);
                    },
                    complete: () => this.isLoading = false
                  });
                } else {
                  this.getCustomer();
                }
              }
            },
            error: err => {
              console.log(err);
            }
          });
        }
      });
    }
  }
}
